import type React from 'react'
import {createContext, use} from 'react'

import type {CommitsFilters} from '../types/commits-types'

const emptyFilters: CommitsFilters = {
  since: null,
  until: null,
  author: null,
  currentBlobPath: '',
  pagination: {
    hasNextPage: false,
    hasPreviousPage: false,
    endCursor: '',
    startCursor: '',
  },
  newPath: null,
  originalBranch: null,
}

const FilterContext = createContext<CommitsFilters>(emptyFilters)

export function FilterProvider({filters, children}: React.PropsWithChildren<{filters: CommitsFilters}>) {
  return <FilterContext value={filters}>{children}</FilterContext>
}

export function useFilters() {
  return use(FilterContext)
}
